import * as api from "../Api/index";
export const getRightOfUseAsset = () => async (dispatch) => {
  try {
    const { data } = await api.getRightOfUseAsset();
    dispatch({ type: "GET_ALL_RIGHT_OF_USE_ASSET", payload: data });
  } catch (error) {}
};
